import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrderResult = _resolveComponent("OrderResult")

  return (_ctx.r)
    ? (_openBlock(), _createBlock(_component_OrderResult, {
        key: 0,
        res: _ctx.r
      }, null, 8, ["res"]))
    : _createCommentVNode("", true)
}